<template>
  <div v-click-outside="()=>isOpen=false" :class="['custom-dropdown', {'open': isOpen, frozen: sortedOptions && sortedOptions.length===1}]">
    <!-- {{ sortedOptions.map((d)=>d.id) }} -->
    <!-- {{ internalChecks }} -->
    <!-- <div class="current" @click="isOpen=!isOpen">{{ internalValue.length }} selected</div> -->
    
    <div class="current" @click="isOpen=!isOpen">{{ currentLabel }}</div>
    <div v-if="isOpen" class="dropdown">
      <div v-if="multiple && options.length >= 5" class="select-helper-container">
        <span @click="selectAll">{{ $t('select_all') }}</span>
        <span class="align-right" @click="unselectAll">{{ $t('unselect_all') }}</span>
      </div>
      <div v-if="timeChildren && multiple" class="slider-wrapper">
        <vue-slider
          v-model="internalValueSlider"
          :data="mappedSortedOp"
          :lazy="true"
          :adsorb="true"
          :silent="true"
          :min-range="1"
          :marks="objectMarks"
          :interval="1"
          :height="3"
          :style="{ padding: '0'}"
          :process-style="{ backgroundColor: 'black' }"
          :tooltip-style="{ backgroundColor: 'black', borderColor: 'black', fontSize: '10px' }"
          :dot-style="{ backgroundColor: 'black', borderColor: 'black', boxShadow: '0.5px 0.5px 2px 1px rgb(0 0 0 / 32%)' }"
        />
      </div>
      <draggable
        v-if="sortedOptions && sortedOptions.length<1000"
        v-model="sortedOptions"
        v-bind="dragOptions"
        @start="drag=true"
        @end="drag=false"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <div
            v-for="(o) in sortedOptions"
            :key="o.id"
            class="option"
            :class="{last:isLast(o),innactive:!isActive(o)}"
          >
            <div class="option-wrapper">
              <div v-if="sortableOptions" class="handle" />
              <div v-if="multiple" class="fake-checkbox-container">
                <label :for="o.id+o.label" class="label">
                  <input
                    :id="o.id+o.label"
                    v-model="internalChecks"
                    :value="o.id"
                    type="checkbox"
                    name="input"
                  >
                  <div class="fake-checkbox" />
                  <div class="label-text">{{ o.label }}</div>
                </label>  
              </div>
              <div v-else class="fake-radio-container">
                <label :for="o.id+o.label" class="label" :class="{selected:internalChecks===o.id}">
                  <input
                    :id="o.id+o.label"
                    v-model="internalChecks"
                    :value="o.id"
                    type="radio"
                  >
                  <div class="fake-radio" />
                  <div class="label-text">{{ o.label }}</div>
                </label>
              </div>
              <!-- <label :for="o.id+o.label" class="label">{{ o.label }}({{ o.id }})</label>   -->
              <!-- <div
                v-if="!hasSubOptions && canChart"
                class="chart-icon"
                :class="{active: isChart(o.id)}"
                @click="toggleChart(o.id)"
              /> -->
              <!-- <div
                v-if="!hasSubOptions && canBold"
                class="star-icon"
                :class="{active: isBold(o.id)}"
                @click="toggleBold(o.id)"
              /> -->
            </div>
            <div v-if="multiple && internalChecks.indexOf(o.id)>=0 && hasSubOptions" class="sub-options">
              <!-- <div class="sub-options-title">{{ internalSubchecks[o.id] }}</div> -->
              <div v-for="so in o.subOptions" :key="so.id" class="sub-option">
                <div v-if="multiple" class="fake-checkbox-container">
                  <label :for="o.id+so.label" class="label">
                    <input
                      :id="o.id+so.label"
                      :value="so.id"
                      :checked="internalSubchecks[o.id].indexOf(so.id)>=0"
                      type="checkbox"
                      @input="(v)=>updateSubCheck(o,so,v)"
                    >
                    <div class="fake-checkbox" />
                    <div class="label-text">{{ so.label }}({{ so.id }})</div>
                  </label>
                </div>
                <!-- <div
                  v-if="canBold"
                  class="star-icon"
                  :class="{active: isBold(o.id,so.id)}"
                  @click="toggleBold(o.id, so.id)"
                /> 
                <div
                  v-if="canChart"
                  class="chart-icon"
                  :class="{active: isChart(o.id,so.id)}"
                  @click="toggleChart(o.id, so.id)"
                /> -->
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import Vue from 'vue'
import draggable from 'vuedraggable'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { t } from '@/i18n'

// import Multiselect from 'vue-multiselect'
export default {
  components: {
    // Multiselect,
    draggable,
    VueSlider,
  },
  directives: {
    ClickOutside,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    options: {},
    value: {},
    multiple: {},
    canBold: {},
    timeChildren: {},
    canChart: {},
    unsortable: { default: false },
  },
  data() {
    return {
      isOpen: false,
      sortedOptions: null,
      drag: false,
    }
  },
  computed: {
    objectMarks() {
      let minDate = this.mappedSortedOp[0]
      let maxDate = this.mappedSortedOp[this.mappedSortedOp.length - 1]
      return {
        [minDate]: {
          label: minDate,
          labelStyle: {
            position: 'absolute',
            left: '5px',
            fontSize: '10px',
          },
        },
        [maxDate]: {
          label: maxDate,
          labelStyle: {
            position: 'absolute',
            left: '-5px',
            fontSize: '10px',
          },
        },
      }
    },
    mappedSortedOp() {
      return this.sortedOptions.map(x => x.label)
    },
    internalValueSlider: {
      get: function () {
        return [
          this.mappedSortedOp.length !== this.internalChecks.length
            ? this.mappedSortedOp[this.sortedOptions.map(x => x.id).indexOf(this.internalChecks[0])]
            : this.mappedSortedOp[0],
          this.mappedSortedOp.length !== this.internalChecks.length
            ? this.mappedSortedOp[
                this.sortedOptions
                  .map(x => x.id)
                  .indexOf(this.internalChecks[this.internalChecks.length - 1])
              ]
            : this.mappedSortedOp[this.mappedSortedOp.length - 1],
        ]
      },
      set: function (newValue) {
        this.rangeChange(newValue[0], newValue[1])
      },
    },
    sortableOptions() {
      return this.multiple && !this.unsortable
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: !this.sortableOptions,
        ghostClass: 'ghost',
      }
    },
    hasSubOptions() {
      return this.options.hasSuboptions
    },
    internalChecks: {
      get() {
        if (!this.internalValue || this.internalValue.length === 0) return []
        else if (this.multiple) return this.internalValue && this.internalValue.map(v => v.value)
        else return this.internalValue[0]?.value
      },

      set(value) {
        if (!this.multiple) value = [value]
        let tmp = this.options
          .map(o => {
            if (value.indexOf(o.id) >= 0) {
              let candidate = this.internalValue?.find(v => v.value === o.id) || {}
              return {
                value: o.id,
                // bold: candidate.bold,
                // whatever: candidate.whatever,
                type: o.type,
                index: candidate.index,
                subOptions:
                  candidate.subOptions ||
                  o.subOptions?.filter(so => so.default).map(so => ({ value: so.id })),
              }
            } else {
              return null
            }
          })
          .filter(d => d)
        this.internalValue = this.setIndexes(tmp)
      },
    },
    internalSubchecks: {
      get() {
        let tmp = this.options.reduce((res, v) => {
          res[v.id] = v.subOptions
            .filter(
              so =>
                this.internalValue
                  .find(d => d.value === v.id)
                  ?.subOptions?.findIndex(ssoo => ssoo.value === so.id) >= 0
            )
            .map(so => so.id)
          return res
        }, [])
        return tmp
      },
      set(subChecks) {
        let tmp = this.options
          .map(o => {
            if (this.internalChecks.indexOf(o.id) >= 0) {
              let candidate = this.internalValue.find(v => v.value === o.id) || {}
              // creamos "so" para los subhecks
              let subOptions = subChecks[o.id].map(sc => {
                return {
                  value: sc,
                }
              })
              //PERO reaprobechamos (para el .chart) si YA estaba en el internalValue!
              subOptions = subOptions.map(so => {
                return candidate.subOptions.find(ssoo => ssoo.value === so.value) || so
              })
              subOptions
              return {
                value: o.id,
                // bold: candidate.bold,
                // whatever: candidate.whatever,
                type: o.type,
                index: candidate.index,
                // subOptions: subOptions,
                // subOptions: subChecks[o.id].map(sc => {
                //   return {
                //     value: sc,
                //   }
                // }),
              }
            } else {
              return null
            }
          })
          .filter(d => d)
        this.internalValue = this.setIndexes(tmp)
      },
    },
    // sortedOptions: {
    //   get() {
    //     let sorted = [...this.options]
    //     // MUY DIFICIL DECIDIR "COMO DEBE FUNCIONAR".... //a no se qeu de alugnam manera se pueda cambiar el ORDER de las "options"....
    //     if (this.multiple) {
    //       sorted.sort((a, b) => {
    //         let foundA = this.internalValue.find(d => d.value === a.id)
    //         let foundB = this.internalValue.find(d => d.value === b.id)
    //         if (foundB && foundA)
    //           return (
    //             (foundA.index !== undefined ? foundA.index : Infinity) -
    //             (foundB.index !== undefined ? foundB.index : Infinity)
    //           )
    //         else if (foundB) return 1
    //         else if (foundA) return -1
    //         else return a.order - b.order
    //       })
    //     }
    //     return sorted
    //   },
    //   set(value) {
    //     this.internalValue.forEach(d => {
    //       d.index = value.findIndex(dd => String(dd.id) === String(d.value))
    //     })
    //     this.internalValue = [...this.internalValue]
    //   },
    // },
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
    currentLabel() {
      if (
        this.internalValue &&
        this.internalValue.length > 1 &&
        this.internalValue.length === this.options.length &&
        Array.isArray(this.internalChecks)
      )
        return t('all_op')
      else if (
        this.internalValue &&
        this.internalValue.length > 1 &&
        Array.isArray(this.internalChecks)
      )
        return `${this.internalValue.length} ${t('selected')}`
      else if (this.internalValue && this.internalValue.length > 0) {
        let val = this.internalValue[0].value
        let opt = this.sortedOptions && this.sortedOptions.find(o => o.id === val)
        return opt ? opt.label : val + '[no label]'
      } else {
        return t('no_op')
      }
    },
  },
  watch: {
    internalChecks() {
      if (!this.multiple) this.isOpen = false
    },
    sortedOptions(newVal, oldVal) {
      if (newVal && oldVal) this.internalValue = this.setIndexes(this.internalValue)
    },
    options: {
      handler(nv, ov) {
        //Si no, no podemos "cambiarl las options" on the fly (para los quickfilters y demas)
        if (JSON.stringify(nv) !== JSON.stringify(ov)) this.initSortedOptions()
      },
      immediate: true,
    },
  },
  mounted() {
    // this.initSortedOptions()
  },
  methods: {
    rangeChange(minVal, maxVal) {
      this.internalChecks = this.sortedOptions
        .map(v => v.id)
        .slice(this.mappedSortedOp.indexOf(minVal), this.mappedSortedOp.indexOf(maxVal) + 1)
    },
    unselectAll() {
      this.internalChecks = []
    },
    selectAll() {
      this.internalChecks = this.options.map(v => v.id)
    },
    initSortedOptions() {
      this.sortedOptions = JSON.parse(JSON.stringify(this.options))
      if (!this.unsortable) {
        this.sortedOptions.sort((a, b) => {
          let foundA = this.internalValue.find(d => d.value === a.id)
          let foundB = this.internalValue.find(d => d.value === b.id)
          if (foundB && foundA)
            return (
              (foundA.index !== undefined ? foundA.index : Infinity) -
              (foundB.index !== undefined ? foundB.index : Infinity)
            )
          else if (foundB) return 1
          else if (foundA) return -1
          else return a.order - b.order
        })
      }
    },
    setIndexes(value) {
      let oldStr = JSON.stringify(value)
      let tmp = JSON.parse(oldStr)
      tmp.forEach(d => {
        d.index = this.sortedOptions.findIndex(dd => String(dd.id) === String(d.value))
      })
      // naaaa.... deberia pero igualemtne LA PRIMERA recalcula... FUFUFUF
      if (oldStr !== JSON.stringify(tmp)) return tmp
      else return value
    },
    isLast(o) {
      if (!this.multiple) return false
      let idx = this.sortedOptions.findIndex(oo => oo.id === o.id)
      let next = this.sortedOptions[idx + 1]
      return (
        next &&
        this.internalValue &&
        this.internalValue.find(v => v.value === o.id) &&
        !this.internalValue.find(v => v.value === next.id)
      )
    },
    isActive(o) {
      if (!this.multiple) return true
      return this.internalValue && this.internalValue.find(v => v.value === o.id)
    },
    isBold(o, so) {
      let candidate = this.internalValue?.find(v => v.value === o)
      if (so) candidate = candidate.subOptions.find(v => v.value === so)
      return candidate?.bold
    },
    toggleBold(o, so) {
      let candidate = this.internalValue.find(v => v.value === o)
      if (so) candidate = candidate.subOptions.find(v => v.value === so)
      if (candidate.bold === undefined) Vue.set(candidate, 'bold', false)
      if (candidate) {
        candidate.bold = !candidate.bold
      }
      this.internalValue = [...this.internalValue]
    },
    isChart(o, so) {
      let candidate = this.internalValue.find(v => v.value === o)
      if (so) candidate = candidate.subOptions.find(v => v.value === so)
      return candidate?.chart
    },
    toggleChart(o, so) {
      let candidate = this.internalValue.find(v => v.value === o)
      if (so) candidate = candidate.subOptions.find(v => v.value === so)
      if (candidate.chart === undefined) Vue.set(candidate, 'chart', false)
      if (candidate) {
        candidate.chart = !candidate.chart
      }
      this.internalValue = [...this.internalValue]
    },
    updateSubCheck(o, so, e) {
      let cehcked = e.target.checked
      if (!cehcked)
        this.internalSubchecks[o.id] = this.internalSubchecks[o.id].filter(s => s !== so.id)
      else this.internalSubchecks[o.id].push(so.id)
      this.internalSubchecks = [...this.internalSubchecks]
    },
  },
}
</script>

<style lang="stylus" scoped>
.custom-dropdown
  position: relative
  flex: 1 1 0%
  border: 1px solid $grey-grey
  border-radius: 8px
  background-color: #fff

  &.open
    border-color: #000

    &:before
      border-color: $bcn-grey

    &:after
      transform: translateY(-50%) rotate(180deg)

  &:before
    position: absolute
    top: -4px
    left: -4px
    z-index: -1
    width: calc(100% + 8px)
    height: calc(100% + 8px)
    border: 4px solid #fff
    border-radius: 8px
    content: ""

  &:after
    m-icon("chevron-down", 24)
    position: absolute
    top: 50%
    right: vw(10px)
    content: ""
    transition: transform 0.15s ease-in-out
    transform: translateY(-50%)
    pointer-events: none

  &.frozen
    opacity: 0.5
    pointer-events: none

    &:before,
    &:after
      display: none

.current
  m-font-size(14, 18)
  padding: vw(6px) vw(40px) vw(6px) vw(12px)
  color: $grey
  cursor: pointer
  min-width: vw(150px)

.slider-wrapper
  padding: 40px 33px 35px
  height: auto

.dropdown
  position: absolute
  top: calc(100% + 3px)
  left: 0
  z-index: 3
  overflow: hidden
  width: 100%
  border: 1px solid $bcn-other-grey
  border-radius: 8px
  background-color: #fff

  .select-helper-container
    display: flex
    justify-content: space-between
    padding: vw(8px) vw(10px) vw(5px)
    width: 100%

    span
      m-font-size(11, 14)
      color: $corporate_color
      cursor: pointer

    .align-right
      text-align: right

  > div
    overflow-y: auto
    max-height: vw(200px)

.option
  m-font-size(14, 18)
  padding-right: vw(6px)
  padding-left: vw(6px)
  word-break: break-word
  overflow-wrap: break-word

  &:first-child
    padding-top: vw(6px)

  &:last-child
    padding-bottom: vw(6px)

.option-wrapper
  display: flex

  .handle
    m-icon("drag", 20)
    margin-top: vw(7px)

.sub-options
  margin-top: vw(5px)

.sub-options-title
  margin-left: vw(5px)

.sub-option
  display: flex
  align-items: center
  padding: vw(5px) 0 vw(5px) vw(36px)

  .label
    flex: 1 1 0%

  > input
    margin-right: vw(5px)

.ghost
  opacity: 0

.fake-checkbox-container,
.fake-radio-container
  flex: 1 1 0%

  > label
    display: flex
    padding: vw(6px) vw(8px)
    width: 100%
    border-radius: 8px
    cursor: pointer

    &.selected
      font-weight: bold

    &:hover
      background-color: $bcn-very-light-grey

    > input
      margin: 0
      width: 0
      height: 0
      opacity: 0

      &:checked
        + .fake-checkbox
          m-icon("check-box", 20)

  .fake-checkbox
    m-icon("check-box-blank", 20)
    margin-top: vw(1px)
    margin-right: vw(10px)

  .label-text
    m-font-size(14, 22)
    flex: 1 1 0%
    cursor: pointer
</style>
